$('[data-action="openContactModal"]').click(function () {
  const $form = $('.js-apo-contact-modal.' + $(this).prop('id'));
  $form.addClass('show');
  // Make the section focusable and set focus on it
  $form.attr('tabindex', '-1').focus();

  $('main').attr('inert', 'true');
  $('footer').attr('inert', 'true');
  $('.sidebar').attr('inert', 'true');

  // Focus trap
  trapFocus($form);
});

$('.service-link.openContactModal').click(function () {
  const $form = $('.js-apo-contact-modal');
  $form.addClass('show');

  // Make the section focusable and set focus on it
  $form.attr('tabindex', '-1').focus();

  // Focus trap
  trapFocus($form);
});

$('.js-apo-contact-modal').keydown(function (e) {
  if (e.key === 'Escape') {
    closeModal($(this));
  }
});

$('.js-apo-contact-modal .js-form-close').click(function () {
  const $form = $(this).closest('.js-apo-contact-modal');
  closeModal($form);
});

function closeModal($form) {
  $form.removeClass('show');
  $form.removeAttr('tabindex'); // Remove tabindex when hiding the modal

  // Remove inert from background content
  $('main').removeAttr('inert');
  $('footer').removeAttr('inert');
  $('.sidebar').removeAttr('inert');
}

// Focus trapping function
function trapFocus(modal) {
  const focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const $focusableElements = modal.find(focusableElements);
  const $firstFocusableElement = $focusableElements.first();
  const $lastFocusableElement = $focusableElements.last();

  $(document).on('keydown', function (e) {
    const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) return;

    if (e.shiftKey) {
      // If Shift + Tab is pressed
      if ($(document.activeElement).is($firstFocusableElement)) {
        e.preventDefault();
        $lastFocusableElement.focus(); // Jump to the last focusable element
      }
    } else {
      // If only Tab is pressed
      if ($(document.activeElement).is($lastFocusableElement)) {
        e.preventDefault();
        $firstFocusableElement.focus(); // Jump to the first focusable element
      }
    }
  });

  // Set focus to the first element in the modal when it's opened
  $firstFocusableElement.focus();
}
